// extracted by mini-css-extract-plugin
export default {"otherPlansRow":"OtherPlans_otherPlansRow__I2EUl","textArea":"OtherPlans_textArea__yzHmW"};